import fetchRequest from '../../helpers/fetchRequest';

export async function getChartTimestamp() {
    const url = `/get-chart-timestamp`;
    const options = {
      method: 'GET',
    };
    return fetchRequest(url, options);
  }